import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { EventOccurrenceSubtaskEntity } from './event-occurrence-subtask.entity';
import { EventEntity } from './event.entity';

@Index('_event_occurrence__fk__event__id_foreign', ['fkEventId'], {})
@Index(
	'_event_occurrence__isCompleted__start__deleted_userId_index',
	['start', 'isCompleted', 'deletedUserId'],
	{},
)
// PD-14959 — the global search catch-up finds the tasks changed since its
// last run by this column every five minutes.
@Index('idx_event_occurrence_modified_date', ['modifiedDate'], {})
@Entity('_event_occurrence')
export class EventOccurrenceEntity extends BaseEntity {
	@Column('int', { name: '_fk__event__id', nullable: true, unsigned: true })
	public fkEventId!: number | null;

	@Column('text', { name: '_subject', nullable: true })
	public subject!: string | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('datetime', { name: '_start', nullable: true })
	public start!: Date | null;

	@Column('datetime', { name: '_end', nullable: true })
	public end!: Date | null;

	@Column({
		type: 'boolean',
		name: '_isCompleted',
		nullable: true,
		width: 1,
		default: () => "'0'",
	})
	public isCompleted!: boolean | null;

	@Column('varchar', {
		name: 'm_sm_priority',
		nullable: true,
		length: 64,
		default: () => "'2'",
	})
	public mSmPriority!: string | null;

	@Column('datetime', { name: '_completed_date', nullable: true })
	public completedDate!: Date | null;

	@Column('int', {
		name: '_completed_userId',
		nullable: true,
		unsigned: true,
	})
	public completedUserId!: number | null;

	@Column('text', { name: '_completion_notes', nullable: true })
	public completionNotes!: string | null;

	@ManyToOne(() => EventEntity, (event) => event.eventOccurrences, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__event__id', referencedColumnName: 'id' }])
	public fkEvent!: EventEntity;

	@OneToMany(
		() => EventOccurrenceSubtaskEntity,
		(eventOccurrenceSubtask) => eventOccurrenceSubtask.fkEventOccurrence,
		{},
	)
	public eventOccurrenceSubtasks!: Array<EventOccurrenceSubtaskEntity>;
}
